/**
 * Option Insert Formula
 * Pure helper for task pane single-option insert: builds the formula string
 * that matches OPTLAB.OPTIONS.OPTION semantics (Excel evaluates; #N/A if not listed).
 */

import { parseOccSymbol } from "../shared/symbols/occOptionSymbol";

/**
 * Build the insert formula for a single option from an OCC symbol.
 * Validates and normalizes the symbol via parseOccSymbol (strict); uses canonical unspaced form.
 *
 * @param occ - OCC option symbol (e.g. "SPY260116C00450000" or "SPY   260116C00450000")
 * @returns Formula string: =OPTLAB.OPTIONS.OPTION("<canonical>")
 * @throws Error if symbol is invalid (parseOccSymbol throws)
 */
export function buildOptionInsertFormula(occ: string): string {
  const parsed = parseOccSymbol(occ);
  const canonical = parsed.formats.unspaced;
  return '=OPTLAB.OPTIONS.OPTION("' + canonical + '")';
}
